import type { ConfigData } from '@plone/registry';

import {
  FolderView,
  CapaView,
  InternalView,
  AllNews,
  NewsGridView,
  LinksView,
  FilesView,
} from 'volto-ministerio-publico-federal/components';
import NewsView from 'volto-ministerio-publico-federal/components/View/News/NewsView';
import NotFoundView from 'volto-ministerio-publico-federal/components/View/NotFound';
import SubHomeView from 'volto-ministerio-publico-federal/components/View/SubHomeView';
import ServicosView from 'volto-ministerio-publico-federal/components/View/ServicosView';
import UnidadeContato from 'volto-ministerio-publico-federal/components/View/UnidadeContato';

export const updateViewsConfig = (config: ConfigData) => {
  config.views = {
    ...config.views,
    layoutViews: {
      ...config.views.layoutViews,
      document_view: InternalView,
      capa_view: CapaView,
      news_view: NewsView,
      news_item_view: NewsView,
      newsitem_view: NewsView,
      listing_view: AllNews,
      folder_view: FolderView,
      news_grid_view: NewsGridView,
      links_view: LinksView,
      files_view: FilesView,
      subhome_view: SubHomeView,
      servicos_view: ServicosView,
      contato_view: UnidadeContato,
    },
    // Todo layout custom em `layoutViews` precisa de um nome aqui: o
    // Display.jsx do core usa `layoutViewsNamesMapping[layout]` como id da
    // mensagem i18n; sem entrada, `formatMessage({ id: undefined })` estoura.
    layoutViewsNamesMapping: {
      ...config.views.layoutViewsNamesMapping,
      document_view: 'Visualização de documento',
      capa_view: 'Visualização de capa',
      news_view: 'Visualização de notícias',
      news_item_view: 'Visualização de notícia',
      newsitem_view: 'Visualização de notícia',
      listing_view: 'Visualização de notícias',
      folder_view: 'Visualização de pasta',
      news_grid_view: 'Visualização de notícias em grade',
      links_view: 'Visualização de links',
      files_view: 'Visualização de arquivos',
      subhome_view: 'Visualização de sub-home',
      servicos_view: 'Visualização da página de serviços',
      contato_view: 'Visualização de contato da unidade',
      // Layouts registrados nos FTIs sem componente próprio aqui: o nome aparece
      // no menu de exibição e no painel de perfis de acesso.
      locations_view: 'Visualização de localizações',
      banner_view: 'Visualização de banner',
      sitemap_view: 'Mapa do site',
      unidade_view: 'Visualização de unidade',
      view: 'Visualização padrão',
    },
    contentTypesViews: {
      ...config.views.contentTypesViews,
      Folder: FolderView,
      Collection: AllNews,
    },
    errorViews: {
      ...config.views.errorViews,
      404: NotFoundView,
    },
  } as ConfigData['views'];
};
export default updateViewsConfig;
